
import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { OverlayTrigger, Tooltip, Row, Col, Container, Card, Form, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import EditBudgetAllocModal from './EditBudgetAllocModal';
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BudgetAlloc = () => {

//  const [isEditable, setIsEditable] = useState(false);
//  const [commonList, setCommonList] = useState([]);
  const [errors, setErrors] = useState({});

  const [budgetList, setBudgetList] = useState([]);
  const [subBudgetList, setSubBudgetList] = useState([]);

  const [showsearchModal, setShowSearchModal] = useState(false);

  // Header State
  const [headerData, setHeaderData] = useState({
    budget_id: '',
    years: '',
    year1: '',
    year2: '',
  });

  const [savedYear1, setSavedYear1] = useState('');

  // Child Table Data
  const [childRows, setChildRows] = useState([
    { irn: '',
      sub_budget_id: '', amount: '', max_amount: '',
      isNew: true,     // new row
      isDirty: false,  // modified row
      isDeleted: false // deleted row (optional)
     }
  ]);

  const SCREEN_MODE = {
    INITIAL: "INITIAL",
    NEW: "NEW",
    PROCEEDED: "PROCEEDED",
    EDIT: "EDIT",
  };

  const [screenMode, setScreenMode] = useState(SCREEN_MODE.INITIAL);

  const isInitial = screenMode === SCREEN_MODE.INITIAL;
  const isNewMode = screenMode === SCREEN_MODE.NEW;
  const isProceeded = screenMode === SCREEN_MODE.PROCEEDED;
  const isEditMode = screenMode === SCREEN_MODE.EDIT;

  const isTableEnabled =
    screenMode === SCREEN_MODE.PROCEEDED ||
    screenMode === SCREEN_MODE.EDIT;

  const [delRows, setDelRows] = useState([{ del_irn: '' }]);

  useEffect(() => {

    const fetchLists = async () => {
      try {
        const [commonRes] = await Promise.all([
          axios.get(`${BASE_URL}/api/ddl_budget_master`),
        ]);

        setBudgetList(commonRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);


  const handleHeaderChange = (e) => {

    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));

  };

  const handleYearBlur = (e) => {

    const year1 = Number(e.target.value);

    if (!year1) return;

    setHeaderData(prev => ({
      ...prev,
      year2: year1 + 1
    }));

  };

  const handleChildChange = (index, e) => {

    let { name, value } = e.target;

    if (name === 'amount') {
      value = value.replace(/,/g, "");
      // Allow only digits and at most one decimal point
      if (!/^\d*\.?\d*$/.test(value)) {
        return; // Ignore invalid input
      }
    }

    const updatedRows = [...childRows];
    updatedRows[index][name] = value;

    // mark as dirty only if it's NOT a new row
    if (!updatedRows[index].isNew) {
      updatedRows[index].isDirty = true;
    }

    setChildRows(updatedRows);

  };

  const handleDtlAmtBlur = (index, e) => {

    const { name, value } = e.target;

    if (value === "") return;

    // ✅ Convert to number and truncate instead of round
    let numericValue = parseFloat(value.replace(/,/g, ""));
    if (isNaN(value)) return;

    // Truncate to two decimals (no rounding)
    numericValue = Math.trunc(numericValue * 100) / 100;

    const formatted = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(numericValue));

    const updated = [...childRows];
    updated[index][name] = formatted;
    setChildRows(updated);

  };

  const addRow = () => {
    const newIndex = childRows.length + 1; // 1-based index
    const newRow = {
      parent_irn: '',
      budget_id: '',
      amount: '',
      max_amount: '',
      isNew: true, isDirty: false,  isDeleted: false
    };
    setChildRows([...childRows, newRow]);
    
  };

  const removeRow = (index) => {
    const updated = [...childRows];
//    const deletedRow = updatedRows[index];

    if (updated[index].isNew) {
      // New row → remove directly
      updated.splice(index, 1);
    } else {
      // Existing row → toggle delete
      updated[index].isDeleted = !updated[index].isDeleted;

      // Optional: if undo delete, also remove dirty flag
      if (!updated[index].isDeleted) {
        updated[index].isDirty = false;
      }
    }

    // updatedRows.splice(index, 1);
    setChildRows(updated);

    // if (deletedRow.parent_irn && Number(deletedRow.parent_irn) > 0) {
    //   setDelRows(prev => [
    //     ...prev,
    //     { del_irn: deletedRow.parent_irn }
    //   ]);
    // }

  };

  const handleNew = () => {

    setScreenMode(SCREEN_MODE.NEW);
    setChildRows([{ sub_budget_id: '', amount: '', max_amount: '', irn: '', isNew: true, isDirty: false,  isDeleted: false }]);
    setDelRows([{ del_irn: '' }]);

    // headerData.year1 = savedYear1;
    // const year2 = +savedYear1 + 1;
    // headerData.years = savedYear1 + '-' + year2;

  };

  const handleProceed = async () => {

    if (!headerData.budget_id || headerData.budget_id === '') {
      setErrors({ budget_id: true });
      toast.error("Please Select Budget");
      return;
    } else if (!headerData.year1 || headerData.year1 < 2020) {
      setErrors({ year1: true });
      toast.error("Please enter Year");
      return;
    }


    setSubBudgetList([]);

    const res = await axios.get(`${BASE_URL}/api/ddl_sub_budget_master`, { params: { p_Bdgt_Id: headerData.budget_id } });

    setSubBudgetList(res.data);

    setScreenMode(SCREEN_MODE.PROCEEDED);

  }

  const handleSave = async () => {

    let lv_err_msg = '';

    for (let i = 0; i < childRows.length; i++) {

       if (!childRows[i].sub_budget_id || childRows[i].sub_budget_id === '') {
          lv_err_msg = 'Please Select Sub-Budget Head at Row # ' + (i + 1);
          break;
       }
       else if (!childRows[i].amount || childRows[i].amount === '0' || childRows[i].amount < 0) {
          lv_err_msg = 'Please enter Sub-Budget Allocation Amount at Row # ' + (i + 1);
          break;
       }

    }

    if (lv_err_msg) {
       toast.error(lv_err_msg);
       return;
    }

    const uniqueSubBudget = new Set();

    for (let i = 0; i < childRows.length; i++) {

      if (uniqueSubBudget.has(childRows[i].sub_budget_id)) {
        setErrors({ rowErrors: { [i]: { childRows: true } } });
        toast.error(`Duplicate Sub-Budget Head selected at Row # ${i + 1}`);
        return;
      }

      uniqueSubBudget.add(childRows[i].sub_budget_id);

    }

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const newRows = childRows.filter(r => r.isNew && !r.isDeleted);
    const updatedRows = childRows.filter(r => r.isDirty && !r.isDeleted);
    const deletedRows = childRows.filter(r => r.isDeleted && !r.isNew);


    const structdata = {
      header: headerData,
      insertedRows: newRows,
      updatedRows: updatedRows,
      deletedRows: deletedRows
    };

    const response = await axios.post(`${BASE_URL}/api/save_budget_alloc`, structdata);

    if (response.data.message === '1') {
      toast.success('Budget Allocation saved successfully.');
      resetPage();
    }
    
  };

  const resetPage = () => {
      setScreenMode(SCREEN_MODE.INITIAL);
      setHeaderData({budget_id: '', year1: '', year2: ''});
      setChildRows([{ irn: '', sub_budget_id: '', amount: '', max_amount: '', isNew: true, isDirty: false,  isDeleted: false  }]);
      setDelRows([{ del_irn: '' }]);

  }

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      resetPage();
    }
  };

  const handleBdgtAllocRowSelect = async (selRow) => {

    setShowSearchModal(false);

    headerData.budget_id = selRow.bgt_id;
    headerData.year1 = selRow.fin_year1;
    headerData.year2 = Number(selRow.fin_year1) + 1;

    const response = await axios.get(`${BASE_URL}/api/get_BudgetAlloc_ById`, {
      params: { p_FinYear1: selRow.fin_year1, p_Bdgt_Id: selRow.bgt_id },
    });

    // headerData.year1 = selRow.fin_year1;
    // const year2 = +selRow.fin_year1 + 1;
    // headerData.years = headerData.year1 + '-' + year2;
    // headerData.irn = response.data[0].parent_irn;

    setSubBudgetList([]);

    const res = await axios.get(`${BASE_URL}/api/ddl_sub_budget_master`, { params: { p_Bdgt_Id: selRow.bgt_id } });

    setSubBudgetList(res.data);

    const tmpData = response.data;

    setChildRows(response.data);

    for (let i = 0; i < tmpData.length; i++) {

      const formatted = new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(parseFloat(tmpData[i].amount));

      const updated = [...tmpData];
      updated[i]["amount"] = formatted;

      setChildRows(updated);

    }

    setScreenMode(SCREEN_MODE.EDIT);

  }

  /// For displaying total at the bottom of the html table.
  const totalAmount = childRows.reduce((total, row) => {
    const amount = parseFloat(String(row.amount || "0").replace(/,/g, ""));
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const totalMaxAmount = childRows.reduce((total, row) => {
    const max_amount = parseFloat(String(row.max_amount || "0").replace(/,/g, ""));
    return total + (isNaN(max_amount) ? 0 : max_amount);
  }, 0);

  const formatAmount = (amount) =>

    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const options_budget = budgetList.map(code => ({
    value: code.bgt_id,
    label: code.bgt_name
  }));


  return (
  
    <Container fluid className="p-3">
      {/* Header Card */}
      <Card className="mb-4 p-3">
        {/* <h5>Maintenance Header</h5> */}
        <Row className="mb-3">

          <Col md={6}>
            <Select
              name="budget_id"
              isDisabled={!isNewMode}
              options={options_budget}
              className={`${errors.budget_id ? "is-invalid" : ""}`}
              value={options_budget.find(option => option.value === headerData.budget_id) || null}
              onChange={(selectedOption) =>
                setHeaderData({
                  ...headerData,
                  budget_id: selectedOption ? selectedOption.value : '',
                })}
              placeholder="-- Select Budget Master --"
            />

          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "80px" }}>Year </InputGroup.Text>
              <input type="number" style={{ textAlign: 'right' }} className="form-control" disabled={!isNewMode} name="year1" 
                onBlur={handleYearBlur}
                value={headerData.year1} onChange={handleHeaderChange} />&nbsp;&nbsp;
              <input type="number" style={{ textAlign: 'right' }} className="form-control" disabled name="year2" value={headerData.year2}  />
            </InputGroup>
          </Col>

          <Col md={2}>
            <Button
              variant="primary"
              disabled={!isNewMode}
              onClick={handleProceed}> Proceed Sub-Budget
            </Button>
          </Col>

        </Row>

          {/* <Col md={9} className="d-flex justify-content-end"> */}
          <div className="d-flex justify-content-end gap-2">
            <Button className="me-2" style={{ width: '100px'}} variant="primary" disabled={!isInitial} onClick={handleNew}>New</Button>
            <Button className="me-2" style={{ width: '100px'}} variant="secondary" disabled={isInitial} onClick={handleClear}>Clear</Button>
            <Button style={{ width: '100px' }} className="me-2" variant="warning"
              disabled={!isInitial} onClick={(e) => (setShowSearchModal(true))}>Edit </Button>
            {showsearchModal && (
              <EditBudgetAllocModal
                show={showsearchModal}
                handleClose={() => setShowSearchModal(false)}
                onRowSelect={handleBdgtAllocRowSelect}
              />
            )}
            <Button className="me-2" style={{ width: '100px'}} variant="success" 
            disabled={!(isProceeded || isEditMode)} onClick={handleSave}>Save</Button>
          {/* </Col> */}
          </div>

      </Card>

      {/* Child Table */}
      <Card className="p-3">
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{width: '5%', textAlign: 'center'}}>#</th>
                <th style={{width: '70%', textAlign: 'left'}}>Sub-Budget Head</th>
                <th style={{width: '15%', textAlign: 'right'}}>Amount</th>
                <th style={{width: '15%', textAlign: 'right'}}>Max Limit</th>
                <th style={{width: '8%', textAlign: 'center'}}>Action</th>
              </tr>
            </thead>
            <tbody>
              {childRows.map((row, index) => (
                <tr key={index} style={{
                    backgroundColor: row.isDeleted ? "#f8d7da" : "",
                    textDecoration: row.isDeleted ? "line-through" : "",
                    opacity: row.isDeleted ? 0.7 : 1
                  }}
                  >
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    <Form.Select name="sub_budget_id" value={row.sub_budget_id}
                      onChange={(e) => handleChildChange(index, e)} disabled={!isTableEnabled} >
                      <option value="">-- Select Sub-Budget -- </option>
                      {subBudgetList.map(sb => (
                        <option key={sb.sub_bgt_id} value={sb.sub_bgt_id}>{sb.sub_bgt_name}</option>
                      ))}
                    </Form.Select>
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isTableEnabled}
                      type="text" className="form-control" name="amount" value={row.amount} 
                      onChange={(e) => handleChildChange(index, e)}
                      onBlur={(e) => handleDtlAmtBlur(index, e)}
                       />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isTableEnabled}
                      type="text" className="form-control" name="max_amount" value={row.max_amount} 
                      onChange={(e) => handleChildChange(index, e)}
                      onBlur={(e) => handleDtlAmtBlur(index, e)}
                       />
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant={row.isDeleted ? "secondary" : "danger"} 
                        onClick={() => removeRow(index)} size="sm">{row.isDeleted ? "Undo" : "Delete"}</Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr style={{ fontWeight: "bold", backgroundColor: "#f2f2f2" }}>
                <td colSpan="2" style={{ textAlign: "right", fontSize: "18px" }}>
                  Total:
                </td>
                <td style={{ textAlign: "right", fontSize: "18px" }}>
                  {formatAmount(totalAmount)} &nbsp;
                </td>
                <td style={{ textAlign: "right", fontSize: "18px" }}>
                  {formatAmount(totalMaxAmount)} &nbsp;
                </td>
                <td></td>
              </tr>
            </tfoot>

          </table>
        </div>

        {/* <div className="mb-3">
          <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
        </div> */}

        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}
          >
            <Button
              variant="primary"
              onClick={addRow}
              disabled={!isTableEnabled}
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                padding: "0",
                fontSize: "30px"
              }}
            >
            +
          </Button>
          </OverlayTrigger>
        </div>

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default BudgetAlloc;
